import React, { useState } from 'react';
import { Plus, Pencil, Trash2, Check, X } from 'lucide-react';
import api from '../../api/client';

// Sconti da regolamento (20/10/2026, titolare): "riduzioni non cumulabili tra loro e applicabili
// esclusivamente ai pacchetti annuali". Qui si definiscono nome, percentuale e sedi; si assegnano
// persona per persona dal Planning (sotto il pacchetto) o da Pagamento corsi. Cambiare la
// percentuale vale per chi lo riceve dopo: chi lo ha già tiene quella di allora.
const vuoto = { nome: '', percentuale: '10', sedi: [] };

export default function ScontiCorsi({ sconti, sediNomi, puoModificare, onCambio }) {
  const [form, setForm] = useState(null); // { id?, nome, percentuale, sedi }
  const [errore, setErrore] = useState('');

  const salva = async (e) => {
    e.preventDefault();
    setErrore('');
    try {
      const body = { nome: form.nome, percentuale: String(form.percentuale).replace(',', '.'), sedi: form.sedi };
      if (form.id) await api.put(`/planning/sconti/${form.id}`, body);
      else await api.post('/planning/sconti', body);
      setForm(null); onCambio();
    } catch (err) { setErrore(err.response?.data?.error || err.message); }
  };
  const cambia = async (sc, dati) => {
    try { await api.put(`/planning/sconti/${sc.id}`, dati); onCambio(); }
    catch (err) { alert('Errore: ' + (err.response?.data?.error || err.message)); }
  };
  const elimina = async (sc) => {
    if (!window.confirm(`Eliminare lo sconto "${sc.nome}"?`)) return;
    try { await api.delete(`/planning/sconti/${sc.id}`); onCambio(); }
    catch (err) { alert('Errore: ' + (err.response?.data?.error || err.message)); }
  };
  const toggleSede = (nome) => setForm(f => ({ ...f, sedi: f.sedi.includes(nome) ? f.sedi.filter(x => x !== nome) : [...f.sedi, nome] }));
  // sedi del ciclo + quelle già scritte negli sconti (se nel ciclo mostrato non ci sono)
  const tutteSedi = [...new Set([...sediNomi, ...(form?.sedi || [])])];

  return (
    <div style={{ marginTop:'18px', borderTop:'1px solid var(--border,#1E1E1E)', paddingTop:'14px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px' }}>
        <div style={s.titolo}>SCONTI (SOLO PACCHETTI ANNUALI)</div>
        {puoModificare && !form && <button style={s.btnSec} onClick={() => { setErrore(''); setForm({ ...vuoto }); }}><Plus size={13}/> Nuovo sconto</button>}
      </div>
      <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-muted,#888)', marginBottom:'10px', lineHeight:1.5 }}>
        Non cumulabili: una persona ne ha al massimo uno. Si scelgono dal Planning, sotto il pacchetto, o qui sotto in ogni riga. Un prezzo personalizzato vince sullo sconto. In ricevuta compare solo il prezzo finale.
      </div>

      {form && (
        <form onSubmit={salva} style={{ background:'var(--bg-input,#1A1A1A)', borderRadius:'8px', padding:'12px', marginBottom:'12px' }}>
          <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) 110px', gap:'10px' }}>
            <div><label style={s.label}>NOME</label><input style={s.inp} value={form.nome} autoFocus onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} placeholder="Es. Studente universitario non lavoratore"/></div>
            <div><label style={s.label}>SCONTO %</label><input style={s.inp} inputMode="decimal" value={form.percentuale} onChange={e => setForm(f => ({ ...f, percentuale: e.target.value }))}/></div>
          </div>
          <label style={{ ...s.label, marginTop:'10px' }}>SEDI (NESSUNA SPUNTA = TUTTE)</label>
          <div style={{ display:'flex', flexWrap:'wrap', gap:'10px' }}>
            {tutteSedi.map(n => (
              <label key={n} style={{ display:'flex', alignItems:'center', gap:'5px', fontSize:'var(--font-size-xs)', cursor:'pointer' }}>
                <input type="checkbox" checked={form.sedi.includes(n)} onChange={() => toggleSede(n)}/> {n}
              </label>
            ))}
          </div>
          {form.id && <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim,#888)', marginTop:'8px' }}>Se cambi la percentuale, chi ha già questo sconto tiene quella di prima.</div>}
          {errore && <div style={{ color:'#DC2626', fontSize:'var(--font-size-sm)', marginTop:'8px' }}>{errore}</div>}
          <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'10px' }}>
            <button type="button" style={s.btnSec} onClick={() => setForm(null)}><X size={13}/> Annulla</button>
            <button type="submit" style={s.btnPri}><Check size={13}/> Salva</button>
          </div>
        </form>
      )}

      {sconti.length === 0 && <div style={{ color:'#555', fontSize:'var(--font-size-sm)', padding:'4px' }}>Nessuno sconto configurato.</div>}
      {sconti.map(sc => (
        <div key={sc.id} style={{ display:'flex', alignItems:'center', gap:'10px', flexWrap:'wrap', padding:'7px 4px', borderBottom:'0.5px solid var(--border,#1E1E1E)', opacity: sc.attivo ? 1 : .5, fontSize:'var(--font-size-sm)' }}>
          <span style={{ fontWeight:700, color:'#15803D', minWidth:'48px' }}>−{sc.percentuale}%</span>
          <span style={{ flex:'1 1 200px', minWidth:0 }}>{sc.nome}</span>
          <span style={{ fontSize:'var(--font-size-xs)', color:'var(--text-muted,#888)' }}>{sc.sedi?.length ? sc.sedi.join(', ') : 'Tutte le sedi'}</span>
          <span style={{ fontSize:'var(--font-size-xs)', color:'var(--text-muted,#888)' }}>{sc._count?.atletiSlot ? `${sc._count.atletiSlot} assegnati` : 'mai usato'}</span>
          {!sc.attivo && <span style={{ fontSize:'var(--font-size-xs)', fontWeight:700, color:'#888' }}>DISATTIVATO</span>}
          {puoModificare && (
            <span style={{ display:'flex', gap:'6px' }}>
              <button type="button" style={s.icona} title="Modifica" onClick={() => { setErrore(''); setForm({ id: sc.id, nome: sc.nome, percentuale: String(sc.percentuale), sedi: sc.sedi || [] }); }}><Pencil size={12}/></button>
              <button type="button" style={{ ...s.icona, color: sc.attivo ? '#EF4444' : '#22C55E' }} title={sc.attivo ? 'Disattiva (chi lo ha già lo tiene)' : 'Riattiva'} onClick={() => cambia(sc, { attivo: !sc.attivo })}>{sc.attivo ? <X size={12}/> : <Check size={12}/>}</button>
              {!sc._count?.atletiSlot && <button type="button" style={{ ...s.icona, color:'#EF4444' }} title="Elimina" onClick={() => elimina(sc)}><Trash2 size={12}/></button>}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}

const s = {
  titolo: { fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-sm)', fontWeight:'800', color:'#F4600C' },
  btnPri: { display:'flex', alignItems:'center', gap:'6px', background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'8px 12px', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  btnSec: { display:'flex', alignItems:'center', gap:'6px', background:'var(--bg-input,#1A1A1A)', color:'var(--text,#fff)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  icona: { background:'none', border:'none', cursor:'pointer', color:'var(--text-muted,#888)', padding:0, display:'flex' },
  label: { fontSize:'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'#555', display:'block', marginBottom:'4px' },
  inp: { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 12px', color:'var(--text,#fff)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
};
